import React, {Component} from 'react';
import {Image} from 'react-konva';
import './stage.css';

/** @class ParallaxLayer
 * An image that scrolls at a different speed than
 * the stage, creating an illusion of depth.
 */
export default class ParallaxLayer extends Component {
  /** @constructor
    * Constructs a new instance of ParallaxLayer
    * @prop {url} image - the image to display
    * @prop {number} scale - the scale of the layer relative to the stage;
    * this simulates depth by scaling the image size and scrolling
    * @prop {number} width - the width of the stage
    * @prop {number} height - the height of the stage
    * @prop {number} scrollLeft - the distance the stage is scrolled horizontally
    * @prop {number} scrollTop - the distance the stage is scrolled vertically
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
  }
  /** @method componentWillMount
    * Loads the image.
    */
  componentWillMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
    }
    image.src = this.props.image;
  }
  /** @function
   * Renders the image sized and scrolled to emulate depth.
   */
  render() {
    return (
      <Image
        image={this.state.image}
        x={this.props.scrollLeft * (1 - this.props.scale)}
        y={this.props.scrollTop * (1 - this.props.scale)}
        width={this.props.width}
        height={this.props.height}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage/parallax-layer.js